import React from "react";
import PropTypes from "prop-types";
import { connectModal } from "redux-modal";
import { RemoveSmall } from "@conserveit/blocks";
import Modal from "../Modal";
import { AssociateIssueSelectContainer } from "../AssociateIssueSelect";
import {
  $Container,
  $Header,
  $SelectionInfo,
  $SelectionLabel,
  $TabLabel,
  CloseButton,
} from "./TriageActionModal.styles";

const TRIAGE_ACTION_MODAL = "TRIAGE_ACTION_MODAL";

const CreateAssociateModal = (props) => {
  const { show, handleHide, equipRuleIds, equipNames, ruleName, syncoId } =
    props;
  return (
    <Modal isOpen={show} onRequestClose={handleHide}>
      <$Container>
        <$Header>
          <$TabLabel>EXISTING ACTIONS</$TabLabel>
          <CloseButton icon={<RemoveSmall />} onClick={handleHide} />
        </$Header>
        <$SelectionInfo>
          <$SelectionLabel>RULE</$SelectionLabel>
          <span>{ruleName}</span>
          <$SelectionLabel>
            EQUIP{equipNames.length > 1 ? "S" : null}
          </$SelectionLabel>
          <span>{equipNames.join(", ")}</span>
        </$SelectionInfo>
        <AssociateIssueSelectContainer
          equipRuleIds={equipRuleIds}
          onHide={props.handleHide}
          syncoId={syncoId}
        />
      </$Container>
    </Modal>
  );
};

CreateAssociateModal.propTypes = {
  handleHide: PropTypes.func.isRequired,
  equipRuleIds: PropTypes.arrayOf(PropTypes.string),
  equipNames: PropTypes.arrayOf(PropTypes.string),
  ruleName: PropTypes.string.isRequired,
};

CreateAssociateModal.defaultProps = {
  equipRuleIds: [],
  equipNames: [],
};

const ConnectedModal = connectModal({
  name: TRIAGE_ACTION_MODAL,
  getModalState: (state) => state.betaModal,
})(CreateAssociateModal);

export default ConnectedModal;
